import { Component, Input } from "@angular/core";
import { EditableTableComponent } from "../../components/tables/editable-table/editable-table.component";
import { GenericService } from "../service/generic.service";
import { ConfirmationService, MessageService } from "primeng/api";

@Component({
	selector: 'cv-generic-editable-table',
	templateUrl: '../../components/tables/editable-table/editable-table.component.html',
	providers: [ConfirmationService, MessageService]
})
export class GenericEditableTableComponent extends EditableTableComponent {
	@Input() integrationId: string;
	@Input() label: string;
	@Input() entity: string;
	@Input() model: any;

	constructor(
		public confirmationService: ConfirmationService,
		public messageService: MessageService,
		protected service: GenericService
	) {
		super(confirmationService, messageService, service);
	}

	ngOnInit(): void {
		this.service.setConfiguration(this.integrationId, this.entity);
		super.ngOnInit();
	}

	onRowEditInit(row: any) {
		this.service.setConfiguration(this.integrationId, this.entity);
		super.onRowEditInit(row);
	}
}